import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const testimonials = [
  {
    id: 1,
    quote: "PayXB has transformed our payment operations. The AI-powered routing has increased our success rates by 40%.",
    author: "Sarah Chen",
    position: "CTO, TechFlow",
    company: "TechFlow",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&auto=format&q=60"
  },
  {
    id: 2,
    quote: "The no-code integration saved us months of development time. We were up and running in just days.",
    author: "Michael Rodriguez",
    position: "Head of Payments",
    company: "GlobalPay",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&auto=format&q=60"
  },
  {
    id: 3,
    quote: "The analytics dashboard gives us unprecedented visibility into our payment operations.",
    author: "Emma Thompson",
    position: "Finance Director",
    company: "FinTech Solutions",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&auto=format&q=60"
  }
];

const brandLogos = [
  { src: '/Visa_Brandmark_White_RGB_2021.png', alt: 'Visa' },
  { src: '/MasterCard-Logo-1979-1990.png', alt: 'Mastercard' },
  { src: '/Stripe wordmark - white.svg', alt: 'Stripe' },
  { src: '/PayPal_White.png', alt: 'PayPal' },
];

const Testimonials: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section id="testimonials" className="py-20 bg-black text-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="section-title text-white">Trusted by Industry Leaders</h2>
          <p className="section-subtitle text-gray-400">
            See how PayXB is transforming payment operations worldwide
          </p>
        </motion.div>

        {/* 3D Testimonial Carousel */}
        <div className="relative h-[500px] perspective-1000">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeIndex}
              initial={{ opacity: 0, rotateY: 90 }}
              animate={{ opacity: 1, rotateY: 0 }}
              exit={{ opacity: 0, rotateY: -90 }}
              transition={{ duration: 0.5 }}
              className="absolute inset-0 flex items-center justify-center"
            >
              <div className="bg-gradient-to-br from-gray-900 to-black p-8 rounded-2xl shadow-3d max-w-3xl mx-auto transform hover:scale-105 transition-transform duration-300">
                <div className="flex flex-col md:flex-row items-center gap-8">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-white">
                    <img
                      src={testimonials[activeIndex].image}
                      alt={testimonials[activeIndex].author}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1">
                    <blockquote className="text-xl md:text-2xl font-light mb-6">
                      "{testimonials[activeIndex].quote}"
                    </blockquote>
                    <div>
                      <p className="font-bold text-lg">{testimonials[activeIndex].author}</p>
                      <p className="text-gray-400">{testimonials[activeIndex].position}</p>
                      <p className="text-gray-500">{testimonials[activeIndex].company}</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center gap-4 mt-8">
          {testimonials.map((_, index) => (
            <motion.button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                activeIndex === index ? 'bg-white scale-125' : 'bg-gray-600'
              }`}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
            />
          ))}
        </div>

        {/* Client Logos */}
        {/**
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-20"
        >
          <div className="text-center mb-8">
            <h3 className="text-xl font-bold mb-2">Trusted by Industry Leaders</h3>
            <p className="text-gray-400">Join hundreds of companies already using PayXB</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center">
            {[1, 2, 3, 4].map((index) => (
              <motion.div
                key={index}
                className="w-32 h-16 bg-gray-800 rounded-lg flex items-center justify-center"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="w-20 h-8 bg-gray-700 rounded animate-pulse-slow" />
              </motion.div>
            ))}
          </div>
        </motion.div>
        */}

        <div className="flex justify-center gap-12 mt-10">
          {brandLogos.map((logo, idx) => (
            <div key={idx} className="bg-gray-800 rounded-xl w-40 h-20 flex items-center justify-center">
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-12 object-contain p-2"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 